// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toasts-container[data-v-546d7a8e]{position:fixed;z-index:40;top:0;left:0;right:0;bottom:0;pointer-events:none;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;padding-bottom:24px;padding-left:16px;padding-right:16px}\n", ""]);
// Exports
module.exports = exports;
